__turbopack_context__.v({
  "dot": "tqo3za_dot",
  "dotSelected": "tqo3za_dotSelected",
});
